import {
  Directive,
  inject,
  Input,
  type OnChanges,
  type SimpleChanges,
} from '@angular/core';

import { ToggleDirective } from '../toggle.directive';

@Directive({
  exportAs: 'myreWithToggle',
  selector: 'myre-toggle, [myreToggle], [myreWithToggle]',
})
export class WithToggleDirective implements OnChanges {
  private _toggleDirective = inject(ToggleDirective, {
    host: true,
    optional: true,
  });

  @Input()
  public myreWithToggle: ToggleDirective;

  public myreToggle: ToggleDirective = this._toggleDirective;

  public ngOnChanges(changes: SimpleChanges): void {
    const { myreWithToggle } = changes;

    if (myreWithToggle) {
      this.myreToggle = this.myreWithToggle || this._toggleDirective;
    }
  }
}
